import { Entity } from "app/core/commons/entity";

export class AttachedFile implements Entity {

    id: number;
    name: string;
    data: string;
    extension: string;
    contentType: string;
    size: number;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/attachedFile.ts